import { RenderField } from '@/form/fields/RenderField';
import { AccordionItem } from '../../components/AccordionItem';
import { AccordionItemContent } from '../../components/AccordionItemContent';
import { AccordionItemHeader } from '../../components/AccordionItemHeader';
import { useNavigation } from '@/navigation/NavigationContex';
import { translate } from '@/translation/translate.ts';

export const AncestryAmerican = () => {
  const { currentSlide } = useNavigation();

  const ancestryAlaskaNative = currentSlide!.fields.find(({ name }) => name === 'ancestryAlaskaNative');
  const ancestryNativeSouth = currentSlide!.fields.find(({ name }) => name === 'ancestryNativeSouth');
  const ancestryNativeNorth = currentSlide!.fields.find(({ name }) => name === 'ancestryNativeNorth');
  const ancestryCaribbeanIndian = currentSlide!.fields.find(({ name }) => name === 'ancestryCaribbeanIndian');
  const ancestryOtherNativeAmerican = currentSlide!.fields.find(({ name }) => name === 'ancestryOtherNativeAmerican');

  return (
    <AccordionItem>
      <AccordionItemHeader>{translate(currentSlide?.titles?.american)}</AccordionItemHeader>
      <AccordionItemContent>
        <RenderField slideId={currentSlide!.id} field={ancestryAlaskaNative!} />
        <RenderField slideId={currentSlide!.id} field={ancestryNativeSouth!} />
        <RenderField slideId={currentSlide!.id} field={ancestryNativeNorth!} />
        <RenderField slideId={currentSlide!.id} field={ancestryCaribbeanIndian!} />
        <RenderField slideId={currentSlide!.id} field={ancestryOtherNativeAmerican!} />
      </AccordionItemContent>
    </AccordionItem>
  );
};
